/* eslint  no-unused-vars: 0 */
import React, {useState, useMemo, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import actions from '../../../redux/actions';
import {useDispatch, useSelector} from 'react-redux';
import base_url, {urlSearchParams} from '../../../baseUrls';
import * as allConstants from '../../../constants/allConstants';
import StatusRenderer from '../../../pieces/grids/statusRenderer';
import HyperlinkCellRenderer from '../../../pieces/grids/hyperlinkCellRenderer';
import InspectionRequirementsRenderer from '../../../pieces/grids/inspectionRequirementsRenderer';
import LineBreakCellRenderer from '../../../pieces/grids/lineBreakCellRenderer';
import RequirementFilter from '../../../pieces/grids/requirementFilter';
import {getJobColumns, jobApiTypes} from '../helpers/jobGridOptions';
import MyPaginatedGrid from '../../../pieces/grids/paginatedGridWrapper';
import  {NewPermissionGate} from '../../../permissions/permissionGate';
import {MaximizableCellRenderer} from '../../../pieces/grids/MaximizableCellRenderer';
import ApiUtils from '../../../utils/apiUtils';
import axios from 'axios';
import {printJobDetails} from '../../../utils/print';
import {useNavigate, useLocation} from 'react-router-dom';
import {companyAndUserUtils} from '../../../utils/companyAndUserUtils';
import Utils from '../../../utils/utils';
import {isContractor, isImpersonating} from '../../../permissions/utils';
import {getInspectionColumns} from '../ipermitJobPages/listViews/inspections/inspectionsGridOptions';
import {orderInspection, jobHasInspection, canDoInspection} from '../helpers/requestCityInspection';
import {useAutocompleteOptions} from '../../../hooks/useAutompleteOptions';
import {COMPANY_ELEMENTS, companyRules} from '../../../permissions/companyAccessControl';
import {ADMIN_ELEMENTS, ipermitAdminRules} from '../../../permissions/ipermitAdminAccessControl';
import {cf1rRules, ELEMENTS_CF1R} from '../../../permissions/ipermitAccessControl/cf1rAccessControl';
import {inspectionRules, ELEMENTS_INSPECTIONS} from '../../../permissions/ipermitAccessControl/inspectionsAccessControl';
import {useGetFilterList} from '../../../hooks/useGetFilterList';
import { getCurrentUserCompanyReducer } from '../../../redux/user/thunks/getCurrentUserData';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
import TransferJobsModal from '../components/transferJobsModal';
import {useGridLayout} from '../../../contextProviders/gridLayoutContext';
const _ = require('lodash');


const AllJobsGrid = (props) => {

  const navigate = useNavigate();
  const location = useLocation();
  const fetchJob = async (jobId) => {
    let url = `${base_url.api}/jobs/${jobId}`;
    const authToken = await ApiUtils.getAccessToken();
    const jobResponse = await axios.get(url, {headers: {Authorization: authToken}});
    return jobResponse;
  };

 
  const jobStatusOptions = useAutocompleteOptions({field: 'jobStatuses'}).options;

  let gridType = props.gridType;

  if (props.inspectionViewOnly) {
    gridType = jobApiTypes.inspections;
  }

  const dispatch = useDispatch();
  const viewController = props.viewController;
  const [components] = useState({
    'statusRenderer': StatusRenderer,
    'hyperlinkCellRenderer': HyperlinkCellRenderer,
    'MaximizableCellRenderer': MaximizableCellRenderer,
    'InspectionRequirementsRenderer': InspectionRequirementsRenderer,
    'LineBreakCellRenderer': LineBreakCellRenderer,
    'requirementFilter': RequirementFilter,
    'booleanCellRenderer': (props) => <input type="checkbox" checked={props.value} readOnly />
  });

  const tagNames =  useGetFilterList({url : `${base_url.api}tagJobs/`}).options; 
  const company = useSelector(state => state.company);

  const user = useSelector(state=> state.user);
  const {removeLayout} = useGridLayout();

  const companyAllowedTests = useMemo(() => company?.allowedTests || [], [company?.allowedTests]);
  const companyAllowedPermits = useMemo(() => company?.allowedPermits || [], [company?.allowedPermits]);

  const isParentCompany = useMemo(() => company?.childCompanies?.length > 0, [company?.childCompanies?.length]);

  const allCompaniesList = useGetFilterList({url: `${base_url.api}companies/all-list`}).options;
  const userCompanies = useMemo(() => {
    if (!allCompaniesList) return null;
    const list = Array.isArray(allCompaniesList)
      ? allCompaniesList
      : (allCompaniesList.companies ?? allCompaniesList.data ?? []);
    return list.map((x) => (typeof x === 'string' ? x : x.name));
  }, [allCompaniesList]);

  const needCompanyByUser = useMemo(() => isParentCompany || (userCompanies?.length > 1), [isParentCompany, userCompanies?.length]);

 

  const handleDisplayJobDetails = (params) => {

    if(!isContractor(viewController.userRole)) {
      //ipermit users
      if(isImpersonating(viewController.userRole, viewController.companyId) && params?.node?.data?.[allConstants.JOB_FIELDS.IS_DRAFT.api_name]) {
       
        openDraft(params?.node?.data.id);

      } else {

        props.viewJobHandler(params?.node?.data.id, true);
      }

    } else {
      //contractor users
      if(params?.node?.data?.[allConstants.JOB_FIELDS.IS_DRAFT.api_name]) {

        //console.log('contractor user =>>  is draft');
        openDraft(params?.node?.data.id);
      } else {

        //console.log('contractr user => not draft ');
        
        props.viewJobHandler(params?.node?.data.id, true);
      }
    }
  };

  const columnDefs = useMemo(()=> {
    // if (!userCompanies) {
    //   return;
    // }
     
    const columns = getJobColumns(handleDisplayJobDetails, 'MaximizableCellRenderer', {...jobStatusOptions}, userCompanies, tagNames?.tags.map ((x) => x.tagName));
    const inspectionColumns = getInspectionColumns(handleDisplayJobDetails, 'MaximizableCellRenderer', jobStatusOptions, viewController.userRole, tagNames?.tags.map ((x) => x.tagName),
      undefined, isImpersonating(viewController.userRole, viewController.companyId), user?.impersonateUserId)

    const head = [
      //columns.id,
      columns.company,
      columns.jobNumber,
      columns.tags,
      columns.tagsReminderDate,
      //columns.isServiceTitan,
    ];

    //head.push(columns.mailingStatus);
    //head.push(columns.mailingStatusChangeDate);

    const tail = [];
    const columnHERS = [];

    tail.push(columns.permitPO);
    tail.push(columns.lastNote);
    tail.push(columns.lastNoteDate);
    tail.push(columns.lastNoteCreatedBy);

    if (viewController.isServiceTitan || !company?.id) {
    //     viewController.userRole === allConstants.ROLES.IPERMIT_USER ||
    //     viewController.userRole === allConstants.ROLES.SYSTEM_ADMIN ||
    //     viewController.userRole === allConstants.ROLES.IPERMIT_ADMIN
    // ) {
      tail.push(columns.isServiceTitan);
      tail.push(columns.serviceTitanJobNumber);
    }
    // HD F# only means something for Home Depot companies; iPermit users
    // (no company) see every company's jobs, so they keep it.
    if (company?.homeDepotId?.trim?.() || !company?.id) {
      tail.push(columns.homeDepotId);
    }

    tail.push(columns.permitExpiredDate);

    switch (gridType) {
    case (jobApiTypes.cf1r):{
      return [...head, ...[
        columns.jobType,
        columns.neededByDate,
        // columns.zone,
        columns.companyNameByUser,
        inspectionColumns.jobType,
        columns.hoName,
        columns.address,
        columns.state,
        columns.assignedCity,
        columns.permitAssignee,
        columns.createdTime,
        columns.permitStatus,
        columns.permitStatusChangeDate,
      ]];
    }
    default: {
      // if (viewController.userRole === allConstants.ROLES.IPERMIT_USER ||
      //   viewController.userRole === allConstants.ROLES.SYSTEM_ADMIN ||
      //   viewController.userRole === allConstants.ROLES.IPERMIT_ADMIN) {
      //   head.push(columns.isServiceTitan);
      //

      if (companyAllowedTests.includes(allConstants.TEST_TYPES.HERS.value) || !company?.id) {
        columnHERS.push(columns.hersStatus);
        columnHERS.push(columns.hersScheduledDate);
      }
      head.push(columns.hoName);
      head.push(columns.address);
      head.push(columns.state);


      if (gridType === jobApiTypes.zohoUnsynced || process.env.NODE_ENV === 'development' || NewPermissionGate({
        user: viewController.user,
        elementPermissions: ipermitAdminRules[ADMIN_ELEMENTS.forceSyncWithCRM],
      })) {
        head.push(columns.notSyncedToCRM);
      }

      head.push(columns.updatedTime);

      if (viewController.userRole === allConstants.ROLES.IPERMIT_USER ||
          viewController.userRole === allConstants.ROLES.SYSTEM_ADMIN ||
          viewController.userRole === allConstants.ROLES.IPERMIT_ADMIN ) { 
        head.push(columns.companyNameByUser);
        head.push(columns.permitAssignee);
      }
      else if (needCompanyByUser) {
        head.push(columns.companyNameByUser);
      }
      head.push(inspectionColumns.jobType);

      if (gridType === jobApiTypes.all && (!companyAllowedTests || !Array.isArray(companyAllowedTests) || companyAllowedTests.includes(allConstants.TEST_TYPES.HERS.value))) {
        if (!_.isEqual(companyAllowedPermits, [allConstants.JOB_TYPES.TESTING_ONLY.value])) {
          head.push(columns.permitStatus);
          head.push(columns.assignedCity);
        }
        return [...head, ...columnHERS, ...[
          inspectionColumns.inspectionStatus,
          //columns.hersStatus,
          //columns.hersScheduledDate,
          columns.createdTime,
          columns.orderedBy,
        ], ...tail];
      } else if (gridType === jobApiTypes.all) {
        if (!_.isEqual(companyAllowedPermits, [allConstants.JOB_TYPES.TESTING_ONLY.value])) {
          head.push(columns.permitStatus);
          head.push(columns.assignedCity);
        }
        head.push(columns.createdTime);
        return [...head, ...columnHERS, ...[
          inspectionColumns.inspectionStatus,
          //columns.hersStatus,
          //columns.hersScheduledDate,
          columns.orderedBy,
        ], ...tail];
      }

      if (gridType === jobApiTypes.hers) {
        return [...head, ...[
          columns.hersStatus,
          columns.assignedCity,
          columns.hersScheduledDate,
          columns.hoPhone,
          columns.createdTime,
          columns.orderedBy,
        ], ...tail];
      }

      if (gridType === jobApiTypes.euc) {
        return [...head, ...columnHERS, ...[
          //columns.hersStatus,
          columns.assignedCity,
          //columns.hersScheduledDate,
          columns.hoPhone,
          columns.createdTime,
          columns.orderedBy,
        ], ...tail];
      }

      if (gridType === jobApiTypes.inspections || props.inspectionViewOnly) {
        return ([...[columns.id,
          inspectionColumns.jobNumber,
          columns.tags,
          columns.tagsReminderDate,
          columns.company,         
          columns.hoName,
          columns.address,
          columns.state,
          needCompanyByUser ? columns.companyNameByUser : inspectionColumns.companyName,
          //inspectionColumns.companyName,
          inspectionColumns.jobType,
          inspectionColumns.assignedCity,
          inspectionColumns.requirements,
          //columns.permitStatus,
          //columns.hersStatus,
          //columns.mailingStatus,
          inspectionColumns.createdTime,
          inspectionColumns.inspectionStatus,
          inspectionColumns.inspectionStatusChangeDate,
          inspectionColumns.callHoCount,
          inspectionColumns.inspectionScheduledDate,
          inspectionColumns.inspectionResult,
        ], ...tail]);
      }

      if (gridType === jobApiTypes.report) {
        return ([...[columns.id,
          inspectionColumns.jobNumber,
          needCompanyByUser ? columns.companyNameByUser : inspectionColumns.companyName,
          // columns.company,
          columns.hoName,
          //columns.adddress,
          columns.hoPhone,
          columns.assignedCity,
          columns.createdTime,
          columns.permitAssignee,
          columns.createdTime,
          columns.permitStatus,
          columns.permitStatusChangeDate,
          columns.hersStatus,
          columns.hersScheduledDate,
          columns.hersStatusChangeDate,
          columns.schedulingStatus,
          columns.schedulingStatusChangeDate,
          columns.mailingStatus,
          columns.mailingStatusChangeDate,
          inspectionColumns.companyName,
          inspectionColumns.jobType,
          inspectionColumns.assignedCity,
          inspectionColumns.requirements,
          inspectionColumns.inspectionStatus,
          inspectionColumns.inspectionStatusChangeDate,
          inspectionColumns.callHoCount,
          inspectionColumns.inspectionScheduledDate,
          inspectionColumns.inspectionResult,
        ], ...tail]);
      }


      if (companyAllowedTests.includes(allConstants.TEST_TYPES.HERS.value)) {
        return [...head, ...[
          columns.permitStatus,
          columns.createdTime,
          columns.assignedCity,
          columns.hersStatus,
          columns.orderedBy,
        ], ...tail];
      } else {
        return [...head, ...[
          columns.permitStatus,
          columns.createdTime,
          columns.assignedCity,
          columns.orderedBy,
        ], ...tail];
      }
    }}
  }, [gridType, jobStatusOptions, user, userCompanies, tagNames, company?.id, company?.homeDepotId]);

  
  // if(!columnDefs || !jobStatusOptions || !tagNames || !company || !components || !dispatch) {
  //   return null;
  // }
  //console.log('Before allJobsGrid UI rendered');


  const isGeneralGrid = ()=> {
    const generalGridTypes = [
      jobApiTypes.all,
      jobApiTypes.permits,
      jobApiTypes.hers,
      jobApiTypes.euc,
    ];
    return generalGridTypes.includes(gridType);
  };

  const getFetchParams = (gridType, failedInspectionsOnly)=> {

    const baseJobsUrl = `${base_url.api}jobs`;
    const baseIpermitJobsUrl = `${base_url.api}ipermit/jobs`;
    let url = baseJobsUrl;
    let params = {};
    let responseKey = 'jobs';
    
    params.showNotSyncedToCRM = props.showNotSyncedToCRM || false;
    // Note: companyId from URL parameters is intentionally not used for API filtering

    if(gridType ===jobApiTypes.permits){
      url = `${baseJobsUrl}/get-permit-jobs`;
    } else if(gridType === jobApiTypes.unreadNote) {
      url = `${baseJobsUrl}/get-unread-note-jobs`;
      params.isForContractor = props.isForContractor;
    } else if(gridType ===jobApiTypes.hers){
      url = `${baseJobsUrl}/get-hers-jobs`;
    } else if(gridType ===jobApiTypes.euc){
      url = `${baseJobsUrl}/get-euc-jobs`;
    } else if(gridType === jobApiTypes.drafts) {
      url = `${baseJobsUrl}/get-drafts`;
    } else if(gridType === jobApiTypes.archivedDrafts) {
      url = `${baseJobsUrl}/get-expired-drafts`;
    } else if(gridType === jobApiTypes.zohoUnsynced) {
      url = `${baseJobsUrl}/get-zoho-unsynced-jobs`;
    } else if(gridType === jobApiTypes.inspections || gridType === jobApiTypes.report) {
      const isFailedOnly = failedInspectionsOnly;
      if(isFailedOnly) {
        url = `${baseJobsUrl}/get-failed-inspections`;
      } else {
        url = `${baseJobsUrl}/get-inspection-jobs`;
      }
      responseKey = 'inspections';
    } else if(gridType === jobApiTypes.cf1r) {
      url = `${baseIpermitJobsUrl}/cf1r`;
    }

    //console.log('url=>' + url);
    //console.log('respKey=>', responseKey);

    return {url: url, respKey: responseKey, options: params};
  };

  const impersonate = async (companyId)=> {
    // Impersonating switches to a different company's columns, so the saved
    // layouts for the job grids no longer apply.
    Object.values(jobApiTypes).forEach((gridType)=> {
      removeLayout(`jobs-${gridType}`);
    });
    const result = await dispatch(actions.impersonate(companyId));
    if(result?.payload?.company?.[allConstants.COMPANY_FIELDS.ID.api_name]){
      navigate(`${allConstants.PATH.JOBS}?${urlSearchParams.view}=${jobApiTypes.all}`);
    }

  };

  const duplicateJob = (jobId)=> {
    navigate(`${allConstants.PATH.CREATE_JOB}?${urlSearchParams.duplicateOfId}=${jobId}`);

  };

  const openDraft = (jobId)=> {

    const searchParams = new URLSearchParams(location.search);
    navigate(`${allConstants.PATH.CREATE_JOB}?${urlSearchParams.draftId}=${jobId}&view=${searchParams.get(urlSearchParams.view)}`);

    //const url = `${allConstants.PATH.CREATE_JOB}?draftId=${jobId}`; 
    //window.open(url, '_blank');

  };


  const printJob = (jobId)=> {
    //  props.parentFetching(true);
    fetchJob(jobId)
      .then((data) => {
        console.log('got job', data.data.data.job);
        printJobDetails(data.data.data.job);
      })
      .catch((error) => {
        // props.parentFetching(false);
        console.log(error);
      });
  };

  const forceAddToCRM = async (jobId, jobNumber)=> {
    try{
      const authToken = await ApiUtils.getAccessToken();
      let url = `${base_url.api}jobs/${jobId}`;
      const jobResponse = await axios.get(url, {headers: {Authorization: authToken}});
      const job = jobResponse?.data?.data?.job;
      if(job && job?.[allConstants.JOB_FIELDS.ZOHO_ID.api_name]) {
        Utils.handleToastMessage({status: 'success'}, `${jobNumber} Already exists on CRM`, undefined, 'crm_force_add_success' );
        return;
      }
      const response = await fetch(

        `${base_url.api}jobs/sync-with-zoho`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: authToken,
          },
          body: JSON.stringify({
            jobsIds: [jobId]
          }),
        }
      );
      let data = await response.json();
      Utils.handleToastMessage(data, `${jobNumber} added to CRM`, undefined, 'crm_force_add_success' );
    } catch(e){
      Utils.errorToastMessage(`Error on force adding to CRM::: ${JSON.stringify(e)}`, 'crm_force_add_error');

    }
    ///sync-with-zoho

  };

  const setCF1RPending = async (job)=> {
    try{
      const isPending = isCf1rPending(job);
      const payload = {
        jobId: job[allConstants.JOB_FIELDS.ID.api_name],
        isCf1rPending: !isPending,
      };
      const message = isPending ? 'CF1R completed' : 'CF1R set to PENDING';
      const response = await ApiUtils.makeApiCall('POST', 'ipermit/jobs/cf1r/update-pending-state', JSON.stringify(payload));
      Utils.handleToastMessage(response, message,  undefined, 'cf1r_pending_success');
      viewController.refreshOnSuccess(response);
    } catch (e) {
      console.log('error on changing CF1R status', e);
    }

  };

  const deleteDraftJob  = async (param)  =>{

    //console.log('Grid parameters');
    //console.log(param);
    try {
      const payload = {
        id: param?.node?.data[allConstants.JOB_FIELDS.ID.api_name],
        isServiceTitan: param?.node.data?.[allConstants.JOB_FIELDS.SERVICE_TITAN_ID.api_name] != undefined

      };
  
      ApiUtils.makeApiCall('POST', '/jobs/delete', JSON.stringify(payload)).
       then( (x) => {
        param?.node?.setDataValue('jobNumber', 'Deleted');
       });
    }
    catch (e) {
      console.log('error on deleting draft job.', e);
    }
  }
  const jobNeedsCF1R = (job)=> {
    if(!job) return false;
    const jobType = job[allConstants.JOB_FIELDS.JOB_TYPE.api_name];
    if(jobType !== allConstants.JOB_TYPES.HVAC_RES.value && jobType !== allConstants.JOB_TYPES.TESTING_ONLY.value) return false;
    const propertyType = job[allConstants.JOB_FIELDS.GENERAL.PROPERTY_TYPE.api_name];
    return propertyType !== allConstants.PROPERTY_TYPES.COMMERCIAL.value;
  };

  const isCf1rPending = (job)=> {
    if(!job) return false;
    return job[allConstants.PERMIT_MODULE_FIELDS.CF1R_IS_PENDING.api_name];
  };

  const isDraftJob = (job) => {
    if (!job) return false;
    return job[allConstants.JOB_FIELDS.IS_DRAFT.api_name];
  }

  const [transferRequest, setTransferRequest] = useState(null);

  /**
   * The rows a bulk action applies to: everything checked in the grid, or just the
   * right-clicked row when nothing is checked.
   */
  const collectSelectedRows = (params)=> {
    const selected = params?.api?.getSelectedRows?.() ?? [];
    if (selected.length > 0) return selected;
    return params?.node?.data ? [params.node.data] : [];
  };

  /**
   * Mirrors what /jobs/transfer-company will accept, so the menu item is only
   * offered when the request would actually be allowed: drafts only, and all of
   * them sitting in one company.
   */
  const canTransferSelection = (params)=> {
    const rows = collectSelectedRows(params);
    if (rows.length === 0) return false;
    if (!rows.every(isDraftJob)) return false;

    const sourceCompanyId = rows[0]?.company?.id;
    if (!sourceCompanyId) return false;
    return rows.every((row)=> row?.company?.id === sourceCompanyId);
  };

  const openTransferModal = (params)=> {
    const rows = collectSelectedRows(params);
    if (rows.length === 0) return;

    setTransferRequest({
      jobs: rows.map((row)=> ({
        id: row[allConstants.JOB_FIELDS.ID.api_name],
        jobNumber: row[allConstants.JOB_FIELDS.JOB_NUMBER.api_name],
      })),
      sourceCompany: {
        id: rows[0]?.company?.id,
        name: rows[0]?.company?.name,
      },
    });
  };

  const getContextMenuItems = (params)=> {

    let standard = [
      {
        name:  'Show Job Details',
        cssClasses: ['blueFont', 'bold'],
        disabled: viewController.selectedMultipleRows(),
        action: () => {handleDisplayJobDetails(params);},
      },
      {
        name: 'Print job',
        action: ()=> printJob(params?.node?.data.id)
      },
      {
        name: 'Duplicate',
        disabled: !companyAndUserUtils.canAddNewEntityToCompany(company) ||
          viewController.selectedMultipleRows() ||
          params?.node?.data?.isDraft||
          (!isContractor(viewController.userRole) && !isImpersonating(viewController.userRole, viewController.companyId)),
        action: ()=> duplicateJob(params?.node?.data?.id)
      },
      {
        name:  'Export Selected (.xlsx)',
        action: () => params.api.exportDataAsExcel(
          {onlySelected: true}
        )
      },
      'copy',
    ];
    if(params?.node?.data?.[allConstants.JOB_FIELDS.IS_DRAFT.api_name]) {
      const deleteCount = isImpersonating(viewController.userRole, viewController.companyId) ? 1 : 0;
      standard.splice(0, deleteCount, {
        name: 'Edit Draft & Submit Job',
        cssClasses: ['redFont', 'bold'],
        disabled: viewController.selectedMultipleRows() ||
            (!isContractor(viewController.userRole) && !isImpersonating(viewController.userRole, viewController.companyId)),
        action: () => {
          openDraft(params?.node?.data.id);
        },
      });
    }

    const separator=[
      'separator'
    ];
    const ipermitOptions = [];
    const ipermitUserOptions = [];

    if(NewPermissionGate({
      user: viewController.user,
      elementPermissions: companyRules[COMPANY_ELEMENTS.impersonate]
    })) {
      ipermitOptions.push({
        name: 'Impersonate',
        disabled: viewController.selectedMultipleRows(),
        action: () => {
          const companyId = params?.node?.data?.company?.id;
          impersonate(companyId);
        },
        cssClasses: ['redFont', 'bold'],
      });
    }

    if(NewPermissionGate({
      user: viewController.user,
      elementPermissions: inspectionRules[ELEMENTS_INSPECTIONS.requestInspection]
    }) &&
      (isGeneralGrid(gridType) || gridType === jobApiTypes.inspections)
    ) {
      ipermitOptions.push({
        name: 'Order Inspection',
        disabled: viewController.selectedMultipleRows() || jobHasInspection(params?.node?.data) || !canDoInspection(params?.node?.data),
        action: () => orderInspection(params?.node?.data.id, false, viewController),
      });
    }
    if(NewPermissionGate({
      user: viewController.user,
      elementPermissions: cf1rRules[ELEMENTS_CF1R.manageCf1r]
    }) &&
      (isGeneralGrid(gridType) || gridType === jobApiTypes.cf1r)) {
      ipermitOptions.push({
        name: isCf1rPending(params?.node?.data) ? 'CF1R Completed' : 'Set CF1R Needed',
        disabled: viewController.selectedMultipleRows() || !jobNeedsCF1R(params?.node?.data),
        action: () => setCF1RPending(params?.node?.data)
      });
    }

    const delDraftMenuItem = {
      name: 'Delete Draft Job',
      disabled: viewController.selectedMultipleRows() || !isDraftJob(params?.node?.data),
      action: () => deleteDraftJob(params)
    }

    ipermitOptions.push(delDraftMenuItem);
    ipermitUserOptions.push(delDraftMenuItem);

    const transferMenuItem = {
      name: 'Transfer Draft(s) to Another Company',
      disabled: !canTransferSelection(params),
      tooltip: 'Move the selected drafts to a parent, sub or sibling company',
      action: () => openTransferModal(params)
    };

    ipermitOptions.push(transferMenuItem);
    ipermitUserOptions.push(transferMenuItem);
    
    const dangerous = [
      {
        name:  'Job JSON',
        action: () => {props.devViewJobHandler(params?.node?.data.id, true);},
      },
      {
        name: 'Force Add to CRM',
        disabled: viewController.selectedMultipleRows() || params?.node?.data?.isDraft,
        action: ()=>{forceAddToCRM(params?.node?.data.id, params?.node?.data[allConstants.JOB_FIELDS.JOB_NUMBER.api_name]).then(r => r);}
      },

      {
        name: 'Sync Notes to CRM',
        disabled: viewController.selectedMultipleRows() || params?.node?.data?.isDraft,
        action: () => {props.crmAlertHandler(params?.node?.data.id, true);}
      }
    ];

    let listOfActions;
    if(viewController.companyId) {
      listOfActions = [...ipermitUserOptions, ...separator, ...standard];

    } else {
      listOfActions = [...ipermitOptions, ...separator, ...standard];
    }
    if(process.env.NODE_ENV === 'development' || NewPermissionGate({
      user: viewController.user,
      elementPermissions: ipermitAdminRules[ADMIN_ELEMENTS.forceSyncWithCRM]
    })) {
      listOfActions = [...listOfActions, 'separator', ...dangerous];
    }

    return listOfActions;

  };

  const inspectionsFailedOnlyFromUrl = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get(urlSearchParams.failedInspections);
  }, [location.search]);

  const fetchParams = useMemo(
    () => getFetchParams(gridType, inspectionsFailedOnlyFromUrl),
    [gridType, inspectionsFailedOnlyFromUrl, props.isForContractor, props.showNotSyncedToCRM],
  );
  const gridApiRef = useRef(null);
  const currentMonthRef = useRef(null);
  const currentWeekRef = useRef(null);
  const filterRetryTimeoutsRef = useRef([]);

  const clearFilterRetryTimeouts = () => {
    filterRetryTimeoutsRef.current.forEach(clearTimeout);
    filterRetryTimeoutsRef.current = [];
  };

  const scheduleFilterRetry = (callback, delay = 100) => {
    const timeoutId = setTimeout(() => {
      filterRetryTimeoutsRef.current = filterRetryTimeoutsRef.current.filter((id) => id !== timeoutId);
      callback();
    }, delay);
    filterRetryTimeoutsRef.current.push(timeoutId);
  };

  // Set grid API reference when grid is registered
  const handleRegisterGrid = (params) => {
    gridApiRef.current = params.api;
    viewController.setGridToParent(params);
  };

  useEffect(() => {
    return () => {
      clearFilterRetryTimeouts();
    };
  }, []);

  // Check for currentMonth URL parameter and set date filter for createdTime column
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const currentMonth = searchParams.get('currentMonth');
    
    // Only run if currentMonth parameter actually changed
    if (currentMonth && currentMonth !== currentMonthRef.current) {
      currentMonthRef.current = currentMonth;
      // Parse the currentMonth parameter (expected format: YYYY-MM-DD, YYYY-MM, or YYYY-M)
      let year, month;
      const parts = currentMonth.split('-');
      
      if (parts.length >= 2) {
        // Format: YYYY-MM-DD, YYYY-MM, or YYYY-M
        year = parseInt(parts[0], 10);
        month = parseInt(parts[1], 10) - 1; // Month is 0-indexed in Date constructor
      } else if (parts.length === 1) {
        // If only one part, assume it's the month and use current year
        const today = new Date();
        year = today.getFullYear();
        month = parseInt(parts[0], 10) - 1;
      } else {
        // Invalid format, use current month
        const today = new Date();
        year = today.getFullYear();
        month = today.getMonth();
      }
      
      // Validate year and month
      if (isNaN(year) || isNaN(month) || month < 0 || month > 11) {
        const today = new Date();
        year = today.getFullYear();
        month = today.getMonth();
      }
      
      const firstDay = new Date(year, month, 1);
      const lastDay = new Date(year, month + 1, 0);
      
      // Format dates as ISO strings (YYYY-MM-DD)
      const dateFrom = firstDay.toISOString().split('T')[0];
      const dateTo = lastDay.toISOString().split('T')[0];
      
      // Set filter on the createdTime column - wait for grid to be ready
      const setFilter = () => {
        if (gridApiRef.current) {
          try {
            // Determine which field to use based on gridType
            const createTimeField = gridType === jobApiTypes.inspections
              ? `cityInspection.${allConstants.JOB_FIELDS.CREATE_TIME.api_name}`
              : allConstants.JOB_FIELDS.CREATE_TIME.api_name;
            
            const filterComponent = gridApiRef.current.getFilterInstance(createTimeField);
            if (filterComponent) {
              filterComponent.setModel({
                filterType: 'date',
                type: 'inRange',
                dateFrom: dateFrom,
                dateTo: dateTo
              });
              gridApiRef.current.onFilterChanged();
            }
          } catch (e) {
            console.log('Error setting date filter:', e);
          }
        } else {
          // Grid not ready yet, try again after a short delay
          scheduleFilterRetry(setFilter);
        }
      };
      
      setFilter();
    } else if (!currentMonth && currentMonthRef.current) {
      // Reset ref when currentMonth is removed from URL
      currentMonthRef.current = null;
    }
  }, [location.search, gridType]);

  // Check for currentWeek URL parameter and set date filter for createTimeField
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const currentWeek = searchParams.get('currentWeek');
    
    // Only run if currentWeek parameter actually changed
    if (currentWeek && currentWeek !== currentWeekRef.current) {
      currentWeekRef.current = currentWeek;
      // Parse the currentWeek parameter (expected format: YYYY-MM-DD)
      let startDate, endDate;
      try {
        const datePattern = /^(\d{4})-(\d{2})-(\d{2})$/;
        const match = currentWeek.match(datePattern);
        if (match) {
          const year = parseInt(match[1], 10);
          const month = parseInt(match[2], 10) - 1; // Month is 0-indexed in Date constructor
          const day = parseInt(match[3], 10);
          
          // Validate date components
          if (!isNaN(year) && !isNaN(month) && !isNaN(day) && month >= 0 && month <= 11 && day >= 1 && day <= 31) {
            startDate = new Date(year, month, day);
            // Ending date is startDate + 6 days
            endDate = new Date(startDate);
            endDate.setDate(endDate.getDate() + 6);
            
            // Validate the dates
            if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
              return; // Invalid date, don't set filter
            }
          } else {
            return; // Invalid date components, don't set filter
          }
        } else {
          return; // Invalid format, don't set filter
        }
      } catch (e) {
        console.log('Error parsing currentWeek:', e);
        return;
      }
      
      // Format dates as ISO strings (YYYY-MM-DD)
      const dateFrom = startDate.toISOString().split('T')[0];
      const dateTo = endDate.toISOString().split('T')[0];
      
      // Set filter on the createdTime column - wait for grid to be ready
      const setFilter = () => {
        if (gridApiRef.current) {
          try {
            // Determine which field to use based on gridType
            const createTimeField = gridType === jobApiTypes.inspections
              ? `cityInspection.${allConstants.JOB_FIELDS.CREATE_TIME.api_name}`
              : allConstants.JOB_FIELDS.CREATE_TIME.api_name;
            
            const filterComponent = gridApiRef.current.getFilterInstance(createTimeField);
            if (filterComponent) {
              filterComponent.setModel({
                filterType: 'date',
                type: 'inRange',
                dateFrom: dateFrom,
                dateTo: dateTo
              });
              gridApiRef.current.onFilterChanged();
            }
          } catch (e) {
            console.log('Error setting date filter for currentWeek:', e);
          }
        } else {
          // Grid not ready yet, try again after a short delay
          scheduleFilterRetry(setFilter);
        }
      };
      
      setFilter();
    } else if (!currentWeek && currentWeekRef.current) {
      // Reset ref when currentWeek is removed from URL
      currentWeekRef.current = null;
    }
  }, [location.search, gridType]);

  // Check for statusName URL parameter and set set filter for permitStatus or inspectionStatus column
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const statusName = searchParams.get('statusName')
    //const statusName = searchParams.get('statusName') ? decodeURIComponent(searchParams.get('statusName')) : null;
    
    if (statusName) {
      // Determine which field to use based on gridType
      const statusField = gridType === jobApiTypes.inspections
        ? `cityInspection.${allConstants.INSPECTION_FIELDS.INSPECTION_STATUS.api_name}`
        : allConstants.JOB_FIELDS.PERMIT_STATUS.api_name;
      
      // Set filter on the status column - wait for grid to be ready
      const setFilter = () => {
        if (gridApiRef.current) {
          try {
            const filterComponent = gridApiRef.current.getFilterInstance(statusField);
            if (filterComponent) {
              filterComponent.setModel({
                filterType: 'set',
                values: [statusName]
              });
              gridApiRef.current.onFilterChanged();
            }
          } catch (e) {
            console.log('Error setting status filter:', e);
          }
        } else {
          // Grid not ready yet, try again after a short delay
          scheduleFilterRetry(setFilter);
        }
      };
      
      setFilter();
    }
  }, [location.search, gridType]);

  // Check for companyName URL parameter and set set filter for companyName column
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const companyNameParam = searchParams.get('companyName');
    
    if (companyNameParam) {
      // Decode URL-encoded company name (handles %20 for spaces, %26 for &, etc.)
      const decodedCompanyName = decodeURIComponent(companyNameParam).trim();
      
      //console.log('companyNameParam', companyNameParam);
      //console.log('decodedCompanyName', decodedCompanyName);
      
      // Construct the field name: parent + field.api_name (same pattern as ColumnDefinition)
      // companyName column uses parent='company' and field=COMPANY_FIELDS.NAME
      const companyNameField = `company.${allConstants.COMPANY_FIELDS.NAME.api_name}`;
      
      // Set filter on the companyName column - wait for grid to be ready
      const setFilter = (retryCount = 0) => {
        if (gridApiRef.current) {
          try {
            const filterComponent = gridApiRef.current.getFilterInstance(companyNameField);
            if (filterComponent) {
              // Get available filter values to find exact match
              const allColumns = gridApiRef.current.getColumnDefs();
              const companyNameCol = allColumns?.find(col => col.field === companyNameField);
              const filterValues = companyNameCol?.filterParams?.values || [];
              
              // If filter values are not available yet and we haven't retried too many times, wait and retry
              if (filterValues.length === 0 && retryCount < 10) {
                scheduleFilterRetry(() => setFilter(retryCount + 1));
                return;
              }
              
              // Try to find exact match first, then try case-insensitive match, then normalize whitespace
              let matchedValue = filterValues.find(val => val === decodedCompanyName);
              if (!matchedValue) {
                // Try case-insensitive match
                matchedValue = filterValues.find(val => val.toLowerCase() === decodedCompanyName.toLowerCase());
              }
              if (!matchedValue) {
                // Try normalizing whitespace (replace multiple spaces/tabs with single space)
                const normalizedDecoded = decodedCompanyName.replace(/\s+/g, ' ').trim();
                matchedValue = filterValues.find(val => {
                  const normalizedVal = val.replace(/\s+/g, ' ').trim();
                  return normalizedVal === normalizedDecoded || normalizedVal.toLowerCase() === normalizedDecoded.toLowerCase();
                });
              }
              
              if (matchedValue) {
                filterComponent.setModel({
                  filterType: 'set',
                  values: [matchedValue]
                });
                gridApiRef.current.onFilterChanged();
                console.log('Company name filter set successfully:', matchedValue);
              } else {
                console.log('Company name not found in filter list. Decoded value:', decodedCompanyName);
                console.log('Available values count:', filterValues.length);
                console.log('First few available values:', filterValues.slice(0, 5));
                // Try using the decoded value directly as fallback
                filterComponent.setModel({
                  filterType: 'set',
                  values: [decodedCompanyName]
                });
                gridApiRef.current.onFilterChanged();
              }
            } else {
              // Filter component not found, retry if we haven't retried too many times
              if (retryCount < 10) {
                scheduleFilterRetry(() => setFilter(retryCount + 1));
              }
            }
          } catch (e) {
            console.log('Error setting companyName filter:', e);
            // Retry on error if we haven't retried too many times
            if (retryCount < 10) {
              scheduleFilterRetry(() => setFilter(retryCount + 1));
            }
          }
        } else {
          // Grid not ready yet, try again after a short delay
          if (retryCount < 10) {
            scheduleFilterRetry(() => setFilter(retryCount + 1));
          }
        }
      };
      
      setFilter(0);
    }
  }, [location.search]);

  return (
    <>
      {tagNames && userCompanies && <MyPaginatedGrid
        columnDefs={columnDefs}
        components={components}
        rowHeight={35}
        colDefOverrides={{ autoHeight: false }}
        gridOptionsOverrides={{ animateRows: false, rowBuffer: 25 }}
        contextMenu={getContextMenuItems}
        onCellDoubleClicked={handleDisplayJobDetails}
        registerGrid={handleRegisterGrid}
        registerTempGrid={viewController.setTempGridToParent}    
        fetchParams={fetchParams}
        pagination={props.pagination}
        onFetchFail={viewController.onFetchFail}
        ls_name={`jobs-${gridType}`}
        defFilterParams={props.defFilterParams}
        draftAction={openDraft}
        additionalFilters={props.additionalFilters}
        refreshTimestamp={viewController.refreshTimestamp}
        globalFilters={props.globalFilters}
        globalSearchFilters={props.globalSearchFilters}
        
        //fieldsToFilterOnEnter={[allConstants.JOB_FIELDS.JOB_NUMBER]}
      />}
      {transferRequest && <TransferJobsModal
        open={true}
        jobs={transferRequest.jobs}
        sourceCompany={transferRequest.sourceCompany}
        handleClose={()=> setTransferRequest(null)}
        onTransferred={()=> viewController.refreshGrid()}
      />}
    </>
  );
};
AllJobsGrid.propTypes = {
  pagination: PropTypes.instanceOf(Object).isRequired,
  devViewJobHandler: PropTypes.func.isRequired,
  crmAlertHandler: PropTypes.func.isRequired,
  viewJobHandler: PropTypes.func.isRequired,
  gridType: PropTypes.oneOf(['hers', 'permits', 'all', 'cf1r', 'draft', 'zoho unsynced']),
  viewController: PropTypes.instanceOf(Object).isRequired,
  defFilterParams: PropTypes.instanceOf(Array),
  additionalFilters: PropTypes.instanceOf(Object),
};

AllJobsGrid.defaultProps = {
  gridType: 'all',
  defFilterParams: [],
  additionalFilters: {}
};
export default AllJobsGrid;
